import React, { useContext, useState } from "react";
import {
  validateForm,
  validateField,
  validationSchema,
} from "../../schemas/loginValidation";
import { SendOtp } from "../../services/auth/SendOtp";
import { DContext } from "../../context/Datacontext";
import Select from "react-select"; 
import { Verification } from "./Verification";
import { IoMdClose } from "react-icons/io";
import Loading from "../../components/Loading";

export const CreateUser = ({ onClose } ) => {
  const { BeURL, currentUser, departmentList , Mandatory , loading ,setLoading} = useContext(DContext);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showOtp, setShowOtp] = useState(false);

  const [form, setForm] = useState({
    fullname: "",
    email: "",
    contact: "",
    password: "",
    confirmPassword: "",
    departments: [],
    isInstructor: true,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (name, value) => {
    // update form
    setForm((prev) => ({ ...prev, [name]: value }));

    // run single-field validation using an updated snapshot
    const error = validateField(
      name,
      value,
      { ...form, [name]: value },
      validationSchema.register
    );

    setErrors((prev) => ({ ...prev, [name]: error }));
  };


  // options: support strings or objects safely, drop empty values and dedupe
  const departmentOptions = Array.from(
    new Map(
      (departmentList || [])
        .map((dept) => {
          // Case 1: dept is string
          if (typeof dept === "string") {
            return null;
          }

          // Case 2: dept is object
          const label = dept?.department?.trim();
          const value = dept?._id;

          if (!label || !value) return null;

          return [value, { value, label, raw: dept }];
        })
        .filter(Boolean)
    ).values()
  );


  // derive role for the new user based on currentUser
  let role = "user";
  if (currentUser) {
    if (currentUser.role === "superadmin") role = "admin";
    else if (currentUser.role === "admin") role = "instructor";
    else role = "user";
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm(form, validationSchema.register);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setLoading(true)
      try {
        const res = await SendOtp({
          BeURL,
          email: form.email,
          purpose: role,
        });
        if (res?.success) {
            setShowOtp(true);
        } else {
          alert(res?.message);
        }
      } catch (error) {
        console.error("Register OTP error", error);
        alert("Something went wrong while sending OTP.");
      }
      finally{
        setLoading(false)
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black/35 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-secondary-50 rounded-xl w-full max-w-md max-h-[700px] overflow-y-auto">
   
        <div className="flex justify-between  items-center sticky top-0 z-50 bg-primary-500 px-3 py-2">

          <div>
            <h2 className="text-lg font-semibold text-secondary-50">
              {`Create ${currentUser?.role === "admin" ? "Instructor" : "Admin"}`}
            </h2>
            <p className="text-sm text-gray-200 mt-1">
              {`Add ${currentUser?.role === "admin" ? "Instructor " : "Admin"} details to get started.`}
            </p>
          </div>

          <button
            onClick={onClose}
            className="text-white"
          >
            <IoMdClose size={20} />
          </button>

        </div>
 
      <div className="w-full max-w-md p-6">
        <form onSubmit={handleSubmit} noValidate className= "space-y-3">
          <div className="mb-4">
            <label htmlFor="fullname" className="text-sm text-gray-600">
                Full Name {Mandatory()}
            </label>
            <input
              id="fullname"
              name="fullname"
              placeholder="Enter your full name"
              value={form.fullname}
              onChange={(e) => handleChange("fullname", e.target.value)}
              className={`w-full border rounded-md px-3 py-2 mt-1
                ${errors.fullname ? "border-red-500" : "border-gray-300"}
                focus:outline-none focus:ring-2 focus:ring-blue-500`}
              aria-invalid={!!errors.fullname}
            />
            {errors.fullname && (
              <p className="text-xs text-red-500 mt-1">{errors.fullname}</p>
            )}
          </div>

          <div className="mb-4">
            <label htmlFor="email" className="text-sm text-gray-600">
                Email Address {Mandatory()}
            </label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="Enter your email"
              value={form.email}
              onChange={(e) => handleChange("email", e.target.value)}
              className={`w-full border rounded-md px-3 py-2 mt-1
                ${errors.email ? "border-red-500" : "border-gray-300"}
                focus:outline-none focus:ring-2 focus:ring-blue-500`}
              aria-invalid={!!errors.email}
            />
            {errors.email && (
              <p className="text-xs text-red-500 mt-1">{errors.email}</p>
            )}
          </div>

          <div className="mb-4">
            <label htmlFor="contact" className="text-sm text-gray-600">
                Contact Number {Mandatory()}
            </label>
            <input
              id="contact"
              name="contact"
              type="tel"
              placeholder="Enter mobile number"
              value={form.contact}
              onChange={(e) => handleChange("contact", e.target.value)}
              className={`w-full border rounded-md px-3 py-2 mt-1
                ${errors.contact ? "border-red-500" : "border-gray-300"}
                focus:outline-none focus:ring-2 focus:ring-blue-500`}
              aria-invalid={!!errors.contact}
            />
            {errors.contact && (
              <p className="text-xs text-red-500 mt-1">{errors.contact}</p>
            )}
          </div>

          <div className="mb-4 relative">
            <label htmlFor="password" className="text-sm text-gray-600">
                Password {Mandatory()}
            </label>
            <input
              id="password"
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              value={form.password}
              onChange={(e) => handleChange("password", e.target.value)}
              className={`w-full border rounded-md px-3 py-2 mt-1
                ${errors.password ? "border-red-500" : "border-gray-300"}
                focus:outline-none focus:ring-2 focus:ring-blue-500`}
              aria-invalid={!!errors.password}
            />
            <button
              type="button"
              onClick={() => setShowPassword((s) => !s)}
              className="absolute right-3 top-9 cursor-pointer text-gray-500"
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              👁
            </button>
            {errors.password && (
              <p className="text-xs text-red-500 mt-1">{errors.password}</p>
            )}
          </div>

          <div className="mb-4 relative">
            <label htmlFor="confirmPassword" className="text-sm text-gray-600">
                Confirm Password {Mandatory()}
            </label>
            <input
              id="confirmPassword"
              name="confirmPassword"
              type={showConfirm ? "text" : "password"}
              placeholder="Re-enter password"
              value={form.confirmPassword}
              onChange={(e) => handleChange("confirmPassword", e.target.value)}
              className={`w-full border rounded-md px-3 py-2 mt-1
                ${errors.confirmPassword ? "border-red-500" : "border-gray-300"}
                focus:outline-none focus:ring-2 focus:ring-blue-500`}
              aria-invalid={!!errors.confirmPassword}
            />
            <button
              type="button"
              onClick={() => setShowConfirm((s) => !s)}
              className="absolute right-3 top-9 cursor-pointer text-gray-500"
              aria-label={showConfirm ? "Hide confirmation password" : "Show confirmation password"}
            >
              👁
            </button>
            {errors.confirmPassword && (
              <p className="text-xs text-red-500 mt-1">{errors.confirmPassword}</p>
            )}
          </div>

          {/* ADMIN ONLY */}
          {currentUser?.role === "admin" && (
            <div className="space-y-4">
              {/* Departments (react-select multi) */}
              <div>
                <p className="text-sm text-gray-600 font-medium mb-2">
                    Select Departments {Mandatory()}
                </p>

                <Select
                  isMulti
                  options={departmentOptions}
                  placeholder="Select departments..."
                  value={departmentOptions.filter((opt) =>
                    form.departments.includes(opt.value)
                  )}
                  onChange={(selected) => {
                    const values = selected ? selected.map((s) => s.value) : [];
                    handleChange("departments", values);
                  }}
                  className="text-sm"
                  classNamePrefix="select"
                  styles={{
                    control: (base) => ({ ...base, borderRadius: 8 }),
                  }}
                  aria-label="Select departments"
                />
              </div>

              {/* Instructor */}
              <div className="flex items-center gap-2">
                <input
                  id="isInstructor"
                  type="checkbox"
                  name="isInstructor"
                  checked={form.isInstructor}
                  onChange={(e) => handleChange("isInstructor", e.target.checked)}
                  className="accent-blue-600"
                />
                <label htmlFor="isInstructor" className="text-sm font-medium text-gray-600">
                  Make as Instructor
                </label>
              </div>
            </div>
          )}
          <button
            type="submit"
            className="w-full bg-primary-600 text-white py-3 rounded-md flex justify-center"
          >
            {loading ? <Loading size={30} className="text-white" /> : "Create Account"}
          </button>
        </form>
      </div>
      </div>

      {showOtp &&     <div className=" inset-0 fixed">
        <Verification form={form} role={role} />
      </div>}
    </div>
  );
};
